export default {
      UserIdentities: 'الهوية|الهويات',
      UserIdentities_no_body: 'هوية',

};
